import { render, staticRenderFns } from "./VPSForgotPwdUserIdComponent.vue?vue&type=template&id=0b93c463&scoped=true"
import script from "./VPSForgotPwdUserIdComponent.vue?vue&type=script&lang=js"
export * from "./VPSForgotPwdUserIdComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotPwdUserIdComponent.vue?vue&type=style&index=0&id=0b93c463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93c463",
  null
  
)

export default component.exports